function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.75 2v5.8H2C2 4.19 4.15 2.02 7.75 2zM22 7.8h-5.75V2c3.6.02 5.75 2.19 5.75 5.8zm0 8.5c-.04 3.55-2.18 5.68-5.75 5.7v-5.7H22zm-14.25 0V22c-3.57-.02-5.71-2.15-5.75-5.7h5.75zm0-7H2v5.5h5.75V9.3zM22 9.3h-5.75v5.5H22V9.3zm-7.25 0h-5.5v5.5h5.5V9.3zm0-7.3h-5.5v5.8h5.5V2zm0 14.3h-5.5V22h5.5v-5.7z"
})));